/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Type_Switch_BodyInputs */



/**
* | output |
* | --- |
* | "Making the preparation again rewrites it completely — what you wrote yourself is lost. Keeping your text changes nothing now; the new type shapes this prepar..." |
*
* @param {Meeting_Prep_Type_Switch_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_type_switch_body = /** @type {((inputs?: Meeting_Prep_Type_Switch_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Type_Switch_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Maak je de voorbereiding opnieuw, dan schrijft Wundo ze volledig opnieuw en gaat je eigen tekst verloren. Behoud je je tekst, dan verandert er nu niets; het nieuwe gesprekstype geldt zodra deze voorbereiding opnieuw gemaakt wordt.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Si vous refaites la préparation, Wundo la réécrit entièrement et votre propre texte est perdu. Si vous gardez votre texte, rien ne change pour l'instant — le nouveau type de conversation s'appliquera dès que cette préparation sera refaite.")
	return /** @type {LocalizedString} */ ("Making the preparation again rewrites it completely — what you wrote yourself is lost. Keeping your text changes nothing now; the new type shapes this preparation the next time it is made.")
});